import React from 'react';
import { Link } from 'react-router-dom';
import { theme } from '../theme';
import { useTheme } from '../context/ThemeContext';

export function Navbar() {
  const { theme: mode, toggle } = useTheme();

  return (
    <header
      className="sticky top-0 z-50 border-b backdrop-blur-md"
      style={{
        background: 'color-mix(in srgb, var(--bg2) 88%, transparent)',
        borderColor: 'var(--border)',
      }}
    >
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-4">
        <Link to="/" className="flex items-center gap-2">
          <span
            className="flex h-10 w-10 items-center justify-center rounded-xl text-xl font-bold"
            style={{
              background: `linear-gradient(135deg, ${theme.primary}, ${theme.secondary})`,
              color: '#fff',
              animation: 'glowPulse 4s ease-in-out infinite',
            }}
          >
            O
          </span>
          <span className="text-lg font-bold tracking-tight" style={{ color: 'var(--text)' }}>
            OnlineDigitalCares
          </span>
        </Link>
        <nav className="hidden items-center gap-8 md:flex">
          {['How it works', 'Agents', 'Pricing'].map((t) => (
            <a
              key={t}
              href={`#${t.toLowerCase().replace(/\s+/g, '-')}`}
              className="text-sm font-medium transition hover:opacity-100"
              style={{ color: 'var(--muted)' }}
            >
              {t}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-2 sm:gap-3">
          <button
            type="button"
            className="odc-theme-btn !h-9 !w-9 !text-base"
            aria-label="Toggle theme"
            onClick={toggle}
          >
            {mode === 'dark' ? '☀️' : '🌙'}
          </button>
          <Link
            to="/login"
            className="hidden rounded-xl px-4 py-2 text-sm font-semibold transition sm:inline-block"
            style={{ color: 'var(--muted)' }}
          >
            Login
          </Link>
          <Link to="/login" className="odc-btn-primary !py-2 !text-xs sm:!text-sm">
            Start Free
          </Link>
        </div>
      </div>
    </header>
  );
}
